import { getUserRoles, isAuthenticated } from '@/utils/auth';
import HistoryPage from '@/views/emergencies/HistoryPage.vue';
import { createRouter, createWebHistory } from 'vue-router';
const HomePage = ()=> import('@/views/OperatorPage.vue');
const NotFound = () => import('@/views/NotFound.vue');
//const AppLayout = ()=> import('@/layouts/AppLayout.vue');
//const AdminLayout = ()=> import('@/layouts/AdminLayout.vue');
//const AuthLayout = ()=>import('@/layouts/AuthLayout.vue')
const LoginPage = ()=>import('@/views/users/LoginPage.vue')
const routes = [
     {
        path: '/',
        name: 'dashboard',
        component: HomePage,
       meta: { requiresAuth: true, showHeader: true, roles: ['operator','admin'] }
    },
     {
        path: '/emergencies/history',
        name: 'history',
        component: HistoryPage,
       meta: { requiresAuth: true, showHeader: true, roles: ['operator','admin'] }
    },
     {
        path: '/login',
        name: 'login',
        component: LoginPage,
       // meta: { requiresAuth: true, showHeader: true, roles: roles.adminDashboardRoles }
    },
    // {
    //     path: '/forbidden',
    //     name: 'forbidden',
    //     component: ForbiddenPage,
    //     meta: { showHeader: false }
    // },
    { path: '/:catchAll(.*)', component: NotFound, meta: { showHeader: false } }
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash };
        }
        return savedPosition || { top: 0 };
    }
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Emergency System'; // Fallback if no title
    const isAuthed = isAuthenticated(); // Implement your authentication check
    // Redirect to login if route requires auth and user is not authenticated
    if (to.meta.requiresAuth && !isAuthed) {
        return next({ name: 'login', query: { redirect: to.fullPath } })
    }

    // Redirect away from auth pages if already logged in
    if (to.meta.requiresGuest && isAuthed) {
        return next({ name: 'dashboard' })
    }

    if(to.path==='/login' && isAuthed)
        return next({ name: 'dashboard' });

    // Handle role-based access control
    if (to.meta.roles && to.meta.roles.length > 0) {
        const userRoles = getUserRoles(); // Example function to get user roles
        const allowedRoles = to.meta.roles;

        // Check if any of the user's roles match the allowed roles
        const hasAccess = userRoles.some(role => allowedRoles.includes(role));

        if (!hasAccess) {
            // Redirect to unauthorized page or handle unauthorized access
            return next('/forbidden'); // Example redirect to unauthorized page
        }
    }

    next()
})



export default router;
